// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import {
    ShippingTrackerDataCollectionModel,
    ShippingTrackerDataModel,
} from "@mcmc/App/Services/ShippingTrackerService";
import { Draft } from "immer";

export type ShippingTrackerDataState = {
    dataView: ShippingTrackerDataModel[] | null;
};

const initialShippingTrackerDataState: ShippingTrackerDataState = { dataView: null };

const xShippingTrackerData = createTypedReducerWithImmer(initialShippingTrackerDataState, {
    "xShippingTracker/CompleteLoadShippingTrackerData": (
        draft: Draft<ShippingTrackerDataState>,
        action: { shippingTrackerData: ShippingTrackerDataCollectionModel },
    ) => {
        draft.dataView = action.shippingTrackerData.shipmentsCollection;
    },
});

(reducers as any).xShippingTrackerData = xShippingTrackerData;

type xShippingTrackerDataReducers = {
    shippingTrackerData: typeof xShippingTrackerData;
};

export type xShippingTrackerDataActions =
    | Parameters<xShippingTrackerDataReducers[keyof xShippingTrackerDataReducers]>[1]
    | AnyAction;
